/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SavedCommoditiesPreviewRow } from "./SavedCommoditiesPreviewRow";
import {
  SavedCommoditiesPreviewRowFromJSON,
  SavedCommoditiesPreviewRowFromJSONTyped,
  SavedCommoditiesPreviewRowToJSON,
  SavedCommoditiesPreviewRowToJSONTyped,
} from "./SavedCommoditiesPreviewRow";

/**
 *
 * @export
 * @interface SavedCommoditiesPreviewResult
 */
export interface SavedCommoditiesPreviewResult {
  /**
   *
   * @type {Array<SavedCommoditiesPreviewRow>}
   * @memberof SavedCommoditiesPreviewResult
   */
  rows: Array<SavedCommoditiesPreviewRow>;
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesPreviewResult
   */
  createCount: number;
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesPreviewResult
   */
  updateCount: number;
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesPreviewResult
   */
  errorCount: number;
}

/**
 * Check if a given object implements the SavedCommoditiesPreviewResult interface.
 */
export function instanceOfSavedCommoditiesPreviewResult(
  value: object,
): value is SavedCommoditiesPreviewResult {
  if (!("rows" in value) || value["rows"] === undefined) return false;
  if (!("createCount" in value) || value["createCount"] === undefined)
    return false;
  if (!("updateCount" in value) || value["updateCount"] === undefined)
    return false;
  if (!("errorCount" in value) || value["errorCount"] === undefined)
    return false;
  return true;
}

export function SavedCommoditiesPreviewResultFromJSON(
  json: any,
): SavedCommoditiesPreviewResult {
  return SavedCommoditiesPreviewResultFromJSONTyped(json, false);
}

export function SavedCommoditiesPreviewResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedCommoditiesPreviewResult {
  if (json == null) {
    return json;
  }
  return {
    rows: (json["rows"] as Array<any>).map(SavedCommoditiesPreviewRowFromJSON),
    createCount: json["createCount"],
    updateCount: json["updateCount"],
    errorCount: json["errorCount"],
  };
}

export function SavedCommoditiesPreviewResultToJSON(
  json: any,
): SavedCommoditiesPreviewResult {
  return SavedCommoditiesPreviewResultToJSONTyped(json, false);
}

export function SavedCommoditiesPreviewResultToJSONTyped(
  value?: SavedCommoditiesPreviewResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rows: (value["rows"] as Array<any>).map(SavedCommoditiesPreviewRowToJSON),
    createCount: value["createCount"],
    updateCount: value["updateCount"],
    errorCount: value["errorCount"],
  };
}
